module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Files/Cloud-upload-89a7f05cf213cd364ef3587b2b9d3d2a.svg";